import { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';

const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:3001';

export default function InboundView() {
  const { authFetch } = useAuth();
  const [rows, setRows] = useState(null);
  useEffect(() => {
    authFetch(`${API_BASE}/api/leads?state=consented`).then(r => r.json())
      .then(d => setRows(d.data || [])).catch(() => setRows([]));
  }, [authFetch]);
  if (rows === null) return <div className="ws-pulse">Loading…</div>;
  if (rows.length === 0) return (
    <div className="sol-empty">
      <h3>No inbound leads yet</h3>
      <p>Sellers appear here when they opt in via the funnel.</p>
    </div>
  );
  return (
    <div>
      <div className="ws-label">Consent funnel — inbound</div>
      {rows.map((l) => (
        <div key={l.id} className="ws-card">
          <div className="ws-row" style={{ borderBottom: 'none', padding: 0 }}>
            <span>{l.property_address || 'Lead'}</span>
            <span className="ws-src">{l.source_list_name ? `src: ${l.source_list_name}` : 'funnel'}</span>
          </div>
          {l.next_appointment_at && (
            <div className="ws-src" style={{ marginTop: 4 }}>
              📅 {new Intl.DateTimeFormat('en-US', { timeZone:'America/New_York', weekday:'short', month:'short', day:'numeric', hour:'numeric', minute:'2-digit' }).format(new Date(l.next_appointment_at))} ET
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
